import React, { Fragment, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { DateRangePicker } from 'react-date-range';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import FormSection from 'components/sales/formSection/formSectionNew';
import localization from 'assets/localization/localization';
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
import DatePicker from 'components/sales/datePicker/datePicker';
import FileUpload from 'components/sales/fileUpload/fileUpload';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import Regex from 'services/utils/regex/Regex';
import { handleFormatDate } from 'constants/dateFormat/dateFormat';
import { handleValidateObj } from 'constants/objValues/objvalues';
import axios from "services/interceptor/Interceptor";
import { ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import Config from "services/config/config";
import { FormGroup } from 'react-bootstrap';

const Milestone = ({
  handleValue,
  totalAmount,
  gateData,
  prefilledData,
  gateDetailsChanged,
  isGateDetailsChanged,
  isRenewal=false
}) => {

  var today = new Date();
  today.setDate(today.getDate() + 1);

  const [inputMilestone, setInputMilestone] = useState([{ stage_id:"", stage_name: "", amt: "", desc: "", inv_creation: ""}]);
  const [inputListDates, setInputListDates] = useState([{ inv_date: "", amt: "", desc: ""}]);
  const [inputRentention, setInputRentention] = useState([{amt: "", months: "", desc: "", stage_id: ""}]);
  const [isLoading, setIsLoading] = useState(false);
  const [solutionStages, setSolutionStages] = useState();
  const [minDate, setMinDate] = useState(today);


  useEffect(() => {
    if (isGateDetailsChanged === true) {
      setInputMilestone([{ stage_id:"", stage_name: "", amt: "", desc: "", inv_creation: ""}]);
      // setInputListDates([{inv_date: "", amt: "", desc: ""}]);
      setInputRentention([{amt: "", months: "", desc: "", stage_id: ""}]);
    }
  }, [isGateDetailsChanged]);

  useEffect(() => {
    if (
      prefilledData?.milestone !== undefined &&
      prefilledData?.milestone !== null
    ) {
      // const {
      //   milestone_data,
      //   date_invoices_data,
      //   retention
      // } = prefilledData?.mileStone;
      setTimeout(() => {
        if (prefilledData?.milestone?.milestone_data) {
          setInputMilestone(prefilledData?.milestone?.milestone_data);
        }
        if (prefilledData?.milestone?.date_invoices_data) {
          setInputListDates(prefilledData?.milestone?.date_invoices_data);
        }
        if (prefilledData?.milestone?.retention) {
          setInputRentention(prefilledData?.milestone?.retention);
        }
        console.log(prefilledData?.milestone?.milestone_count);
        if (prefilledData?.milestone?.milestone_count != 0) {
          gateDetailsChanged(false);
        }
      }, 100);

    }
  }, [prefilledData]);

  const handleMilestoneChange = (val, index, type) => {
    const list = [...inputMilestone];
    if (type === 'inv_creation') {
      list[index][type] = val.id;
      list[index]['inv_creation_value'] = val.value;
    } else {
      list[index][type] = val;
    }
    setInputMilestone(list);
  };

  const handleDateInvChange = (val, index, type) => {
    const list = [...inputListDates];
    list[index][type] = val;
    setInputListDates(list);
  };

  const handleRetentionChange = (val, index, type) => {
    // console.log(val);
    const list = [...inputRentention];
    if (type === 'post_stage') {
      list[index]['stage_id'] = val.id;
      list[index]['post_stage_value'] = val.value;
    } else {
      list[index][type] = val;
    }
    setInputRentention(list);
  };

  // Add/Remove Dated entries
  const handleAddDateClick = () => {
    setInputListDates([...inputListDates, { inv_date: "", amt: "", desc: ""}]);
  };
  const handleRemoveDateClick = index => {
    const list = [...inputListDates];
    list.splice(index, 1);
    setInputListDates(list);
  };
  // Add/Remove Retention entries
  const handleAddRetentionClick = () => {
    setInputRentention([...inputRentention, {amt: "", months: "", desc: "", stage_id: ""}]);
  };
  const handleRemoveRetentionClick = index => {
    const list = [...inputRentention];
    list.splice(index, 1);
    setInputRentention(list);
  };
  async function handleAddMilestone() {
    try {
      gateDetailsChanged(false);
      // console.log(gateData);
      if (gateData !== null) {
        setIsLoading(true);
        let url;
        url = Config.postSales.getSolutionStages;
        const payload = {
          gates_data: gateData
        };
        const {data} = await axios.post(url, payload);
        if (data.response.status == true) {
          if (data.response.data?.solution) {
            setInputMilestone(data.response.data.solution);
            setSolutionStages(data.response.data.stages);
          }
        } else {
          toast.error("Some error occurred!");
        }
        setIsLoading(false);
      } else {
        setIsLoading(true);
        let url;
        url = Config.postSales.getSolutionStages;
        const payload = {
          gates_data: []
        };
        const {data} = await axios.post(url, payload);
        if (data.response.status == true) {
          if (data.response.data?.solution) {
            // setInputMilestone(data.response.data.solution);
            setSolutionStages(data.response.data.stages);
          }
        } else {
          toast.error("Some error occurred!");
        }
        setIsLoading(false);
        // toast.error('Please select gate first!');
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || 'Something went wrong, Please try again')
      setIsLoading(false);
    }
  };
  useEffect(()=>{
    handleAddMilestone();
  },[])

  useEffect(() => {
    handleValue({milestone_data: inputMilestone, date_invoices_data: inputListDates, retention: inputRentention});
  }, [inputMilestone, inputListDates, inputRentention]);

  // console.log(totalAmount);
  return (
    <Fragment>
      <FormSection title={localization.mileStone} isLoading={isLoading}>
        {isRenewal == false &&
          <>
          {isGateDetailsChanged === true ?
            <div className="form-btn full-width">
              <button className="btn btn-primary" onClick={handleAddMilestone}>Add Milestone</button>
            </div>
            : (
              <>
                {inputMilestone.map((x, i) => {
                  return (
                    <div className="row form-group">
                      <div className="col-md-3 col-sm-12">
                        <ConstantInput
                          label={localization.siteStages}
                          value={x?.stage_name}
                          disabled
                        />
                      </div>
                      <div className="col-md-2 col-sm-12">
                        <ConstantInput
                          label={localization.amount}
                          type="number"
                          className="indianrupee"
                          isPrefix
                          prefixText={'₹'}
                          regex={Regex.number.test(
                            x?.amt
                          )}
                          handleChange={(val) =>
                            handleMilestoneChange(val, i, "amt")
                          }
                          value={x?.amt}
                        />
                      </div>
                      <div className="col-md-4 col-sm-12">
                        <ConstantInput
                          label={localization.description}
                          handleChange={(val) =>
                            handleMilestoneChange(val, i, "desc")
                          }
                          value={x?.desc}
                        />
                      </div>
                      <div className="col-md-2 col-sm-12">
                        <DropDownInput
                          data={[
                            {name: 'Yes', id: 1},
                            {name: 'No', id: 2}
                          ]}
                          label={localization.createInvoice}
                          getIdValue={(val) => handleMilestoneChange(val, i, 'inv_creation')}
                          value={x?.inv_creation_value}
                        />
                      </div>
                    </div>
                  );
                })}
                {/* Retention Invoices */}
                <strong className="d-block w-100 my-3">
                  {localization.retentionInvoice}
                </strong>
                {inputRentention.map((x, i) => {
                  return (
                    <div className="row form-group">

                      <div className="col-md-3 col-sm-12">
                        <ConstantInput
                          label={localization.description}
                          handleChange={(val) =>
                            handleRetentionChange(val, i, "desc")
                          }
                          value={x?.desc}
                        />
                      </div>
                      <div className="col-md-2 col-sm-12">
                        <ConstantInput
                          label={localization.amount}
                          type="number"
                          className="indianrupee"
                          isPrefix
                          prefixText={'₹'}
                          regex={Regex.number.test(
                            x?.amt
                          )}
                          handleChange={(val) =>
                            handleRetentionChange(val, i, "amt")
                          }
                          value={x?.amt}
                        />
                      </div>
                      <div className="col-md-2 col-sm-12">
                        <ConstantInput
                          label={localization.afterMonths}
                          handleChange={(val) =>
                            handleRetentionChange(val, i, "months")
                          }
                          type="number"
                          value={x?.months}
                        />
                      </div>
                      <div className="col-md-3 col-sm-12">
                        <DropDownInput
                          data={solutionStages}
                          label={localization.stage}
                          getIdValue={(val) => handleRetentionChange(val, i, 'post_stage')}
                          value={x?.post_stage_value}
                        />
                      </div>
                      {inputRentention.length !== 1 &&
                        <div className="col-md-2 col-sm-5">
                          <button
                            onClick={() => handleRemoveRetentionClick(i)}
                            className="mr10 btn btn-sm btn-danger">Remove
                          </button>
                        </div>
                      }
                      {inputRentention.length - 1 === i &&
                        <div className="col-md-2 col-sm-5">
                          <button className="btn btn-sm btn-primary" onClick={handleAddRetentionClick}>Add</button>
                        </div>
                      }
                    </div>
                  );
                })}
              </>
            )
          }
          </>
        }
            {/* Dated Invoices */}
            {/* <strong className="d-block w-100 my-3">
              {localization.datedInvoice}
            </strong> */}
            {inputListDates.map((x, i) => {
              return(
                <>
                {isRenewal == true &&
                 <>
                 <div className="row form-group">
                   <div className="col-md-3 col-sm-12">
                     <DatePicker
                       handleChange={(val) =>
                         handleDateInvChange(val, i, "inv_date")
                       }
                       label={localization.invoiceDate}
                       required={false}
                       minimumDate={minDate}
                       value={x?.inv_date}
                     />
                   </div>
                   <div className="col-md-2 col-sm-12">
                     <ConstantInput
                       label={localization.amount}
                       type="number"
                       className="indianrupee"
                       isPrefix
                       prefixText={'₹'}
                       regex={Regex.number.test(
                         x?.amt
                       )}
                       handleChange={(val) =>
                         handleDateInvChange(val, i, "amt")
                       }
                       value={x?.amt}
                     />
                   </div>
                   <div className="col-md-4 col-sm-12">
                     <ConstantInput
                       label={localization.description}
                       handleChange={(val) =>
                         handleDateInvChange(val, i, "desc")
                       }
                       value={x?.desc}
                     />
                   </div>
                   {inputListDates.length !== 1 && 
                     <div className="col-md-2 col-sm-5">
                     <button
                     onClick={() => handleRemoveDateClick(i)} 
                     className="mr10 btn btn-sm btn-danger">Remove</button>
                     </div>
                     }
                     {inputListDates.length - 1 === i && 
                     <div className="col-md-2 col-sm-5">
                     <button className="btn btn-sm btn-primary" onClick={handleAddDateClick}>Add</button>
                     </div>
                   }
                 </div>
                 </>
                }
                </> 
              );
            })}

            
            
      </FormSection>
    </Fragment>
  );
};

Milestone.propTypes = {
  handleValue: PropTypes.func,
};

export default Milestone;
